@if (bonds) {
  <div class="grid-x">
    @if (!externalView) {
      <div class="cell small-12">
        <h4 class="bold">{{ orgName }}</h4>
      </div>
    }
    <div class="cell medium-5">
      <div class="grid-x">
        <div class="cell small-8">
          <h2 class="h5 no-margin">Bonding Required:</h2>
          <p class="h2 bold no-margin">{{requiredBondingAmount}}</p>
          <p class="small-font-size no-margin">Minimum - see i icon</p>
        </div>
        <div class="cell small-4">
          @if (bondingInfo) {
            <span class="no-margin no-padding display-inline-block"
              [popover]="{ text: bondingInfo, position: 'bottom' }">
              <svg-icon icon="icon-info" class="small dark-gray"></svg-icon>
            </span>
          }
        </div>
      </div>
    </div>
    <div class="cell medium-5">
      <h2 class="h5 no-margin red" [ngClass]="{ 'red': !isCompliant }">Bonding Provided:</h2>
      <p class="h2 bold" [ngClass]="{ 'red': !isCompliant }">{{activeBondingAmount}}</p>
    </div>
    <div class="cell medium-2 text-align-right">
      @if (canAddBond() && externalView) {
        <button class="button" (click)="addBond()" aria-label="Add Bond">Add Bond</button>
      }
      <button (click)="recalculate()" class="button">Recalculate</button>
    </div>
    <div class="cell small-12 minor-margin-top"><p class="small-font-size italic no-margin-bottom">The amount of financial assurance listed does not include any additional financial assurance that may additionally be required as a result of a court order, chief's order, compliance agreement, or a temporary inactive status authorization</p></div>
  </div>
}
<div class="grid-x">
  <ag-grid-angular [gridOptions]="gridOptions" [rowData]="bonds" class="data-grid " [attr.aria-label]="gridAriaLabel"></ag-grid-angular>
</div>
